import MentoringAvatar from './MentoringAvatar.vue';

export * from './components';
export default MentoringAvatar;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/avatar/index.ts